<template lang="pug">
#selecionar-car
    .fields
        .input-field
            i.el-icon-search
            input(
                :placeholder='$t("laudos.digiteONumeroDoCar ")',
                v-mask='`XX-XXXXXXX-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX`',
                v-model='dados.car',
                type='text',
                @input='debounceBuscarCar',
                @keyup.enter='buscarCar'
            )

        el-select(
            v-model='dados.camada',
            :placeholder='$t("laudos.selecioneCamada")',
            :loading='carregandoListas',
            filterable
        )
            el-option(
                v-for='(camada, index) in camadas',
                :key='`selecionar-camada-${index}`',
                :label='camada.nome',
                :value='camada.id'
            )
        el-select(
            v-model='dados.safraId',
            :loading='carregandoListas',
            :placeholder='$t("laudos.selecioneSafra")',
            filterable
        )
            el-option(
                v-for='(safra, index) in safras',
                :key='`selecionar-safra-${index}`',
                :label='safra.safraAno',
                :value='safra.id'
            )
        el-select(
            v-model='dados.culturaId',
            :loading='carregandoListas',
            :placeholder='$t("laudos.selecionaCultura")',
            filterable
        )
            el-option(
                v-for='(item, index) in culturas',
                :key='`${item.codigo}-${index}`',
                :label='item.nome',
                :value='item.id'
            )
        el-date-picker(
            v-model='dados.periodoCobertura',
            type='daterange',
            :range-separator='$t("laudos.a")',
            :start-placeholder='$t("laudos.dataInicial")',
            :end-placeholder='$t("laudos.dataFinal")',
            format='dd/MM/yyyy',
            :clearable='false'
        )
        .obersvacao
            el-input.textarea(
                v-model='dados.observacao',
                :placeholder='$t("laudos.observacao")',
                type='textarea',
                :maxlength='500',
                resize='none'
            )
            span.length {{ dados.observacao.length }}/500
    .dados-car(v-if='mostrarDados')
        h3.dados-car__title {{ $t('laudos.informacoesDoCar') }}
        span.dados-car__lable {{ `${$t('laudos.codigo')}: ` }}
            span.dados-car__text {{ carDados.codigo }}
        span.dados-car__lable {{ `${$t('laudos.areaHa')}: ` }}
            span.dados-car__text {{ carDados.areaHa }}
        span.dados-car__lable {{ `${$t('mensagens.comuns.municipioUf')}: ` }}
            span.dados-car__text {{ carDados.municipioUF }}
        span.dados-car__lable {{ `${$t('laudos.situacao')}: ` }}
            span.dados-car__text {{ carDados.situacao }}
    el-divider.custom-divider
    .footer(slot='footer')
        BaseButton(type='outline', @click='cancelarModal') {{ $t('mensagens.comuns.cancelar') }}
        BaseButton(
            type='primary',
            @click='cadastrarLaudos',
            :disabled='isValid'
        ) {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import UtilsService from '@/modules/laudos/services/UtilsService';
import formatters from '@/modules/laudos/utils/formatters';
import LaudosService from '@/modules/laudos/services/LaudosService';
import StatusCar from '@/constants/StatusCar';
import CarUtils from '@/modules/laudos/utils/CarUtils';
import { mapGetters } from 'vuex';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';

export default {
    name: 'SelecionarCar',
    emits: ['cancelar-modal', 'getLaudos', 'carJaCadastradosEncontrados'],
    components: {
        BaseButton
    },
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        },
        camadas: {
            type: Array,
            required: true
        },
        safras: {
            type: Array,
            required: true
        },
        culturas: {
            type: Array,
            required: true
        },
        carregandoListas: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mostrarDados: false,
            carDados: {},
            existeCarNaBase: false,
            informacaoLaudosTipo: [],
            timeDebounce: 0,
            dados: {
                car: '',
                observacao: '',
                safraId: '',
                camada: '',
                culturaId: '',
                periodoCobertura: []
            }
        };
    },
    computed: {
        isValid() {
            const car = !(this.dados.car && this.existeCarNaBase);
            const camada = !this.dados.camada;
            const safraId = !this.dados.safraId;
            const [dataInicio, dataFim] = this.dados.periodoCobertura;
            const culturaId = !this.dados.culturaId;
            const periodoCobertura = !this.dados.periodoCobertura?.length;
            const periodoCoberturaInvalido =
                new Date(dataFim).getTime() < new Date(dataInicio).getTime();

            return (
                car ||
                camada ||
                safraId ||
                periodoCobertura ||
                periodoCoberturaInvalido ||
                culturaId
            );
        },
        ...mapGetters(['usuarioLogado'])
    },
    methods: {
        debounceBuscarCar() {
            this.existeCarNaBase = false;
            this.mostrarDados = false;
            clearTimeout(this.timeDebounce);

            if (this.dados.car === this.carDados?.codigo) {
                this.mostrarDados = true;
                this.existeCarNaBase = true;
                return;
            }

            this.timeDebounce = setTimeout(() => {
                const formatoCarValido = CarUtils.isCar(this.dados.car);

                if (formatoCarValido) {
                    this.buscarCar();
                }
            }, 1000);
        },
        async buscarCar() {
            const formatoCarInvalido = !CarUtils.isCar(this.dados.car);

            if (formatoCarInvalido) {
                return this.$notify.warning({
                    message: this.$t('laudos.erro.carInvalido')
                });
            }

            try {
                const car = this.dados.car;
                const { data } = await UtilsService.getDadosCARSemGeometria(
                    car
                );

                this.carDados = {
                    areaHa: formatters.formatNumber(data.areaHa, 2),
                    municipioUF: `${data.nomeMunicipio}/${data.uf}`,
                    situacao: StatusCar[data.situacao],
                    condicao: data.situacao,
                    codigo: data.codigo
                };
                this.mostrarDados = true;
                this.existeCarNaBase = true;
            } catch (error) {
                this.carDados = null;
                this.existeCarNaBase = false;
                this.mostrarDados = false;
                this.$notify.error({
                    message: this.$t('laudos.erro.ocorreuUmErroAoBuscarCar')
                });
                throw error;
            }
        },
        async cadastrarLaudos() {
            const dataInicioCobertura = new Date(
                this.dados.periodoCobertura[0]
            );
            const dataFimCobertura = new Date(this.dados.periodoCobertura[1]);

            const informacaoLaudos = [
                {
                    car: {
                        codigo: this.carDados.codigo,
                        condicao: this.carDados.condicao
                    },
                    observacao: this.dados.observacao,
                    safraId: this.dados.safraId,
                    camadasId: [this.dados.camada],
                    culturaId: this.dados.culturaId,
                    dataInicioCobertura,
                    dataFimCobertura,
                    tipoLaudoId: this.tipoLaudo
                }
            ];

            try {
                await LaudosService.cadastrarLaudos({ informacaoLaudos });
                this.$notify.success({
                    message: this.$t('laudos.solicitacaoRealizadaComSucesso')
                });
                this.$emit('getLaudos');
                this.cancelarModal();
            } catch (error) {
                this.$notify.error({
                    message: this.$t('laudos.erro.erroAoCadastrarLaudo')
                });
            }
        },
        cancelarModal() {
            this.$emit('cancelar-modal');
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-car {
    .fields {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;

        .el-select,
        .el-date-editor {
            width: 50%;
        }
        .obersvacao {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            width: 50%;
            gap: 4px;
            .textarea {
                width: 100%;
            }
            .length {
                font-size: 12px;
                color: var(--primary);
            }
        }
        .input-field {
            height: 40px;
            border-radius: 4px;
            width: 50%;
            display: flex;
            justify-content: center;
            border: 1px solid #dcdfe6;

            i.el-icon-search {
                color: var(--gray);
                font-size: 16px;
                display: flex;
                align-items: center;
                margin: 0 8px;
            }

            input {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                margin: 0;
                padding: 0;
                color: var(--text-disabled);
                &::placeholder {
                    color: #c0c4cc;
                }
            }
            &:focus-within {
                border: 1px solid var(--primary);
            }
        }
    }
    .dados-car {
        color: var(--primary);
        width: 100%;
        margin: 16px 0;
        display: flex;
        flex-direction: column;
        &__title {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 8px;
        }
        &__lable {
            font-size: 14px;
            font-weight: 600;
        }
        &__text {
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 2px;
        }
    }
    .footer {
        display: flex;
        justify-content: space-between;
        gap: 16px;
    }

    .custom-divider {
        margin: 16px 0 !important;
    }
}
</style>
